<!--<table mat-table class="mat-elevation-z8">
  <thead>
  <tr>
    <th>Zeitpunkt</th>
    <th>Fehlermeldung</th>
    <th>Stacktrace</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let error of errors">
    <td>{{ error.time | date:'short' }}</td>
    <td>{{ error.message }}</td>
    <td><pre>{{ JSON.stringify(error) }}</pre></td>
  </tr>
  </tbody>
</table>-->
<div><button mat-button color="primary" class="button" (click)="clear()">Fehlerliste löschen</button></div>

<div class="table-responsive">
  <h2>Fehlerübersicht</h2>
  <table mat-table [dataSource]="errors" class="mat-elevation-z8">
    <ng-container matColumnDef="time">
      <th mat-header-cell *matHeaderCellDef>Zeitpunkt</th>
      <td mat-cell *matCellDef="let error">{{ error.time | date:'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="message">
      <th mat-header-cell *matHeaderCellDef>Message</th>
      <td mat-cell *matCellDef="let error">{{ error.message }}</td>
    </ng-container>

    <ng-container matColumnDef="stack">
      <th mat-header-cell *matHeaderCellDef>Stack</th>
      <td mat-cell *matCellDef="let error">{{ JSON.stringify(error.fullError) }}</td>
    </ng-container>

    <!-- Define the displayed columns order -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let error; columns: displayedColumns;"></tr>
  </table>
</div>
